import { useAppSelector } from '@app/hooks';
import { useYearsQuery } from '@shared/api/catalogApi';

import { selectStoredYear } from './uiSlice';

/**
 * The calendar year the user works in: their last choice if that year is open,
 * otherwise the firm's current year. `years` lists every opened year.
 */
export function useProcessingYear(): { year: number; years: number[]; isLoading: boolean } {
  const stored = useAppSelector(selectStoredYear);
  const { data, isLoading } = useYearsQuery(undefined);
  const fallback = new Date().getFullYear();
  const years = data?.years ?? [];
  const current = data?.current ?? fallback;
  const year = stored && years.includes(stored) ? stored : current;
  return { year, years, isLoading };
}
